export type AppSurface = "web" | "desktop" | "menubar";

export interface AppBootstrap {
  readonly surface: AppSurface;
  readonly pathname: string;
  readonly initialAction?: "farm-share";
}

const ROUTE_PATHS = {
  farm: "/",
  portfolio: "/portfolio",
  "portfolio-new": "/portfolio/new",
  slimes: "/slimes",
  observation: "/observe",
  calendar: "/calendar",
  settings: "/settings",
} as const;

export function isTauriRuntime(
  candidate: unknown = typeof window === "undefined" ? undefined : window,
): boolean {
  return Boolean(
    candidate &&
      typeof candidate === "object" &&
      "__TAURI_INTERNALS__" in candidate,
  );
}

export function resolveAppBootstrap(
  href: string,
  tauriRuntime = isTauriRuntime(),
): AppBootstrap {
  const url = new URL(href, "http://localhost");
  if (!tauriRuntime) {
    return { surface: "web", pathname: url.pathname };
  }

  const requestedSurface = url.searchParams.get("surface");
  const surface: AppSurface =
    requestedSurface === "menubar" ? "menubar" : "desktop";
  const requestedRoute = url.searchParams.get("route");
  const initialAction =
    surface === "desktop" && requestedRoute === "farm-share"
      ? "farm-share" as const
      : undefined;
  const pathname =
    surface === "menubar"
      ? "/"
      : initialAction
        ? "/"
      : ROUTE_PATHS[
          requestedRoute as keyof typeof ROUTE_PATHS
        ] ?? "/";

  return {
    surface,
    pathname,
    ...(initialAction ? { initialAction } : {}),
  };
}
